export default {"src":"/_next/static/media/icon-close.1fb0b2d4.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};